import { render, staticRenderFns } from "./dialogOpen.vue?vue&type=template&id=1a10c5da&scoped=true"
import script from "./dialogOpen.vue?vue&type=script&lang=js"
export * from "./dialogOpen.vue?vue&type=script&lang=js"
import style0 from "./dialogOpen.vue?vue&type=style&index=0&id=1a10c5da&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a10c5da",
  null
  
)

export default component.exports